import { configureStore, combineReducers } from '@reduxjs/toolkit';

import authReducer from './slices/auth';
import userReducer from './slices/user';
import lessonReducer from './slices/lesson';
import builderReducer from './slices/builder';

// https://stackoverflow.com/a/35641992
const rootReducer = (state, action) => {
  if (action.type ==='auth/logOutSuccess') {
    state = undefined;
  }
  return appReducer(state, action);
}

const appReducer = combineReducers({
  auth: authReducer,
  user: userReducer,
  lesson: lessonReducer,
  builder: builderReducer,
});

export default configureStore({
  reducer: rootReducer,
});
